// Visual source of truth: docs/specs/2026-09-29-entity-class-workspace-avatars.md
// ("Labels and copy-ID").

@layer base-components {
    .labelled {
        display: inline-flex;
        align-items: center;
        gap: var(--space-8);
    }
}
